import React from 'react';
import { PersonVitalInsights, PersonVitalTimeFrame, PersonVitalType } from '@redux/person/personTypes';
import { CircledCustomIcon, TableIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import style from './Charts.scss';
import { HeartBreathChart } from './HeartBreathChart/HeartBreathChart';
import { InsightsLineChart } from './InsightsLineChart/InsightsLineChart';
import { SleepChart } from './SleepChart/SleepChart';

export type ChartProps = {
  timeZoneId: string;
  personVitalInsights?: PersonVitalInsights | null;
  vitalType: PersonVitalType;
  timeFrame: PersonVitalTimeFrame;
  selectedDate: Date;
  onDaySelect?: (date: Date) => void;
  minRate?: number;
  maxRate?: number;
  minControlRate?: number;
  maxControlRate?: number;
  isLoadingData: boolean;
  onChartDataAvailabilityChange?: (hasData: boolean) => void;
};

export const Charts: React.FC<ChartProps> = ({ vitalType, isLoadingData, ...generalProps }) => {
  if (isLoadingData) {
    return (
      <div className={style.noDataChartContainer}>
        <CircledCustomIcon icon={TableIcon} />
        <Text>Loading...</Text>
      </div>
    );
  }

  switch (vitalType) {
    case PersonVitalType.SLEEP:
      return <SleepChart {...generalProps} />;
    case PersonVitalType.HEART_RATE:
    case PersonVitalType.BREATHING_RATE:
      return <HeartBreathChart {...generalProps} vitalType={vitalType} />;
    case PersonVitalType.BED_EXITS:
    case PersonVitalType.DAY_SLEEP_TIME:
    case PersonVitalType.NIGHT_AWAKE_TIME:
    case PersonVitalType.NIGHT_SLEEP_TIME:
      return <InsightsLineChart {...generalProps} vitalType={vitalType} />;
    default:
      return <></>;
  }
};
